import React,{useEffect, useState,useContext, useRef} from 'react';
import checkmark from '../images/checkmark.svg';
import square from '../images/square.svg'
import small_square from '../images/small_square.svg'
import small_checkmark from '../images/small_checkmark.svg'
import edit from '../images/edit.png'
import iconScrub from '../images/icon_scrubb.png'
import downArrow from "../images/arrow-down.svg";
// import Draggable from "react-draggable";
import EditModal from './Modals/EditModal'
import alertIcon from '../images/Icon-Altert_Small.png';
import { keyContext } from '../components/KeyContext';

import moment from 'moment';
import { useFocusContext } from 'react-day-picker';
import InternetModal     from './Modals/InternetModal';
import InternetShowModal from './Modals/InternetShowModal';
import InternetSellModal from './Modals/InternetSellModal';
import NoteModal from './Modals/NoteModal';
import { th } from 'date-fns/locale';
import { useNavigate } from "react-router-dom";
import ErrorModal from './Modals/ErrorModal';

function FilmWidget({index, film, extendedBackColor,timelineBackColor,   priceDivBackColor,     start_Time,showTime,      end_Time,  salNr,
  internetOrderAll, internetSellAll, internetShowAll, ticketSellAll, ticketOrderAll, saveEditBtn, theWidth, arrtypename,price,webresinfo, webbuyinfo,webshowinfo,buyenabled,resenabled, movieLength, adTrailer, eventEdited,event_no,ref_no, theEvent, editedevent,movieNameColor,activeColor,  popupbg2, popupbg3, all_events, eventsEdit,numbered,daysEvent, theDraggedElm, dragging}) {

  const { selectAllFilmAtOnce, setSelectAllFilmAtOnce, selectedDate,calendarShow , setModalOpen, setMoviesSelected, moviesSelected , deletebtnclk,anyMovieSelected, setAnyMovieSelected,webEditing,editedEvId, setDivOpened,savebtnclk,alertEvents,setalertEvents,seteventEdit,eventsChanged,eventSaveObj, setEventSaveObj, setShowErrorModal,setErrorNo,setErrorText, setShowFilm, setShowDropdown, setClickedMovieDiv, setWaitingModal,setApiLoader,errorType, setErrorType,errorStatus, setErrorStatus,logOut,eventPushCheck,showErrorModal,errorNo,errorText,showTimePeriod} = useContext(keyContext)

   const navigate = useNavigate();
 
  const key = sessionStorage.getItem("key");
  
  const at = theEvent.eventObject.WebreserveInfo?.startTime
 
  const activeDate= moment('2000-01-01', 'YYYY-MM-DD').add(theEvent.eventObject.WebreserveInfo?.startDate - 146097, 'days').format('DD/MM/YY')

   const activeTime =  moment.utc(at*1000).format('HH:mm')
   const activeText =  `Aktiv fra ${activeDate} kl. ${activeTime}`
   const totalTimeInMin = movieLength+adTrailer

  const [modalShown, toggleModal]             = useState(false);
  // const [editmodalShown, setEditmodalShown]   = useState(false);
  const [internetmodalShown, setInternetmodalShown]   = useState(false);
  const [intersellmodal, setIntersellmodal] = useState(false)
  const [intershowmodal,setIntershowmodal]  = useState(false)
  const [webData,setWebData] = useState()
  const [popupTitle,setPopupTitle]      = useState('')
  const [popupSubTtl1, setPopupSubTtl1] = useState('')
  const [popupSubTtl2, setPopupSubTtl2] = useState('')
  const [noteModalOpen, setnoteModalOpen] = useState();
  // const [popupSubTitle1, setPopup]
  const [isShown, setIsShown]                 = useState(false);
  const [ openEventNo, setOpenEventNo ]       = useState()
  const [isActive, setIsActive]               = useState(false);
  const [activeDrag, setActiveDrags]          = useState(0);
  const [movieSelected, setMovieSelected]     = useState(false);
  const [movieDivOpen, setMovieDivOpen]       = useState(false);
  const [internetOrder, setInternetOrder]     = useState()
  const [internetSell, setInternetSell]       = useState()
  const [internetShow, setInternetShow]       = useState()
  const [ticketSellSell, setTicketSellSell]   = useState()
  const [ticketSellOrder, setTicketSellOrder] = useState()
  const [numberedSeat, setNumberedSeat]       = useState(theEvent.handleNumberedSeat)
  const [staffInfoShown,setStaffInfoShown]    = useState(false)
  const [webInfoShown,setWebInfoShown]        = useState(false)
  const [staffText,setStaffText]              = useState('')
  const [webText, setWebText]                 = useState('');
  const [ staffTextInput, setStaffTextInput ] = useState('')
  const [webTextInput, setWebTextInput]       = useState('');
  const [eventEdit, setEventEdit]             = useState(false);  // which is true/False in theEvent
  const [movieUnselect, setMovieUnselect]     = useState();


  useEffect(() => {
    eventsEdit.length && eventsEdit.map((ev) => { 
         all_events.map((oe) => {
            if(ev.No === oe.No) {
                if(ev.No === theEvent.event_No) {
                  setEventEdit(true)
                 }
         }
     })    
    })
    if(theEvent.eventObject.RefNo > 0) {
      setEventEdit(true)
    }
   
  }, [theEvent,eventsEdit,all_events]);


  // useEffect(() => {
  //   if(isShown === true ) setDivOpened(true)
  //     else setDivOpened(false)
  // }, [isShown]);
//  console.log(theEvent)

  const [showActiveText,setShowActiveText] = useState(false)

  useEffect(() => {
    if(theEvent.eventObject.WebreserveInfo?.startDate) { 
        if(theEvent.eventObject.WebreserveInfo?.startDate !== 0 && theEvent.eventObject.WebreserveInfo?.startTime !== 0) setShowActiveText(true)
    }
  }, [theEvent]);

  useEffect(() => {
   setInternetOrder    (webresinfo  === 1 ? true :  false)
   setInternetSell     (webbuyinfo  === 1 ? true :  false)
   setInternetShow     (webshowinfo === 1 ? true :  false)
   setTicketSellSell   (buyenabled  === 1 ? true :  false)
   setTicketSellOrder  (resenabled  === 1 ? true :  false)
   setNumberedSeat     (numbered === true ? true :  false)
},[webresinfo,webbuyinfo,webshowinfo,buyenabled,resenabled,numbered,theEvent])

  const [aclicked,setAclicked] = useState(false) 
  const [bclicked,setBclicked] = useState(false)
  const [cclicked,setCclicked] = useState(false)
  const [dclicked,setDclicked] = useState(false)
  const [eclicked,setEclicked] = useState(false)
  const [numberedBtnClk,setNumberedBtnClk] = useState(false)
 
// useEffect(() => {
//    setAclicked(false)
// }, [selectedDate]);

  useEffect(() => {
     
     setStaffText(theEvent.eventObject.StaffInfo)
     setWebText(theEvent.eventObject.WebInfo)
    // setStaffText('just one hi')
  },[theEvent])
  
  function handleNumberedSeat () {
   
    setNumberedSeat((current) => !current)  // hasNumberedSeats
    setNumberedBtnClk((current) => !current)
  }



  const [reEdit, setReEdit] = useState(false);

  function handleStaffInfo (e) {   
    setStaffTextInput( e.target.innerHTML)
    if(webText) setReEdit(true)
    // setStaffText(e.target.value)
  }

  function handleWebInfo (e) { 
    setWebTextInput( e.target.innerHTML)
    if(staffText) setReEdit(true)
    // setStaffText(e.target.value)
  }

  const [clicked, setClicked] = useState();
  // const [open, setopen] = useState(false);
  let clicks = 0

  
  const handleClick = ( event_no) => {
   
  //  console.log(isShown, 'is shown')
    setClickedMovieDiv(event_no)
    setClicked(event_no)
   
    // console.log(clicked % 2 === 0 , 'if even')
     setMovieDivOpen((current) => !current)

    //  let isEven =clicked % 2 === 0
     setIsActive(current => !current); 

     // setOpenedDivsEvent(event_no)
       setOpenEventNo(event_no)  
       setStaffInfoShown(false)
       setWebInfoShown(false)
      

            var dropdowns = document.getElementsByClassName("dropdown2-content");
            var i;
            for (i = 0; i < dropdowns.length; i++) {
                    var openDropdown = dropdowns[i];
                
                    // or if divs display is not set to block
                     if(dropdowns[i].id == event_no && dropdowns[i].style.display == 'none' ) { 
                      dropdowns[i].style.display='block'
                 
                     }
                     else  { 
                       dropdowns[i].style.display='none'
                   
                     }
              
            }
  
  };
 
  useEffect(() => {
       let divs=  document.getElementsByClassName("dropdown2-content")
        var i;
            for (i = 0; i < divs.length; i++) {
              divs[i].style.display='none'
            }
  }, [selectedDate]);


  const staffInfoClick = () => {
    setStaffInfoShown((current) => !current)
    setReEdit(false)
    setStaffTextInput('')
  }

  const webInfoClick = () => {
    setWebInfoShown((current) => !current)
    setReEdit(false)
    setWebTextInput('')
  }

  useEffect(() => {
    modalShown === true ? setModalOpen(true) :  setModalOpen(false)
    modalShown === true && setShowFilm(false)
  },[modalShown,setModalOpen, setShowFilm])


 useEffect(() => {
   calendarShow === true && setIsShown(false)
 },[calendarShow])


// console.log(movieSelected, 'movie selected')
const [the_result, setThe_result] = useState([])

let flag = false

  function fetchEventSave (event) {
    event.AllowOverlap = 1
     setWaitingModal(true)
    
      fetch(`https://biograf.ebillet.dk/systemnative/report.asmx/man_event_save` ,{
        method: "POST",     
        headers: {
        'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
        'Content-Type':  'application/x-www-form-urlencoded',    
       },     
       body:`Key=${key}&eventdata=${JSON.stringify(event)}`     
      })
      .then(res =>  { 
          
          
            flag =  true
         
        if(res.status === 200) {
          return   res.json() 

        }
        else {
          setShowErrorModal(true)
          setErrorStatus(res.status)
          setErrorType(res.type)       
        }
       
      })
      .then(result => { 

        setWaitingModal(false)
        setApiLoader(false)
           
            if(result.Result === 1) { 
                 theEvent.eventObject= result              
                 setEventSaveObj(result) 
                 setAclicked(false)   
                 setBclicked(false)
                 setCclicked(false)
                 setDclicked(false)
                 setEclicked(false)
                 setNumberedBtnClk(false)
                 setnoteModalOpen(false)
                 setReEdit(false)
             }
          else if(result.Result === -1) {
            // console.log('call event push check')
            eventPushCheck()
          }
               else if (result.Result === 0) {
           // log out
           logOut()
           navigate('/')         
         }
             else {
                 setShowErrorModal(true)
                 setErrorNo(result.Result)
                 setErrorText(result.ErrorDescription)
              }
          
        }) 
       
        setTimeout(function () {
          if(flag === false) {
          
            setApiLoader(true)
         
            
          } 
         }, 2000)
  }



  useEffect(() => {
 
    
     if(aclicked === true || bclicked === true || cclicked === true || dclicked === true || eclicked === true || numberedBtnClk === true ) {
             theEvent.eventObject.WebreserveInfo  ?  
            (theEvent.eventObject.WebreserveInfo.enabled = internetOrder     === false ? 0 : 1) 
           :(theEvent.eventObject.WebreserveInfo = {enabled:internetOrder    === false ? 0 : 1})

             theEvent.eventObject.WebbuyInfo ? 
            (theEvent.eventObject.WebbuyInfo.enabled     = internetSell     === false ? 0 : 1) 
           :(theEvent.eventObject.Webbuyinfo = {enabled: internetSell       === false ? 0 : 1})

             theEvent.eventObject.WebshowInfo? 
            (  theEvent.eventObject.WebshowInfo.enabled    = internetShow  === false ? 0 : 1) 
           :( theEvent.eventObject.WebshowInfo = {enabled:internetShow     === false ? 0 : 1})

             theEvent.eventObject.BuyEnabled             = ticketSellSell  === false ? 0 : 1

            theEvent.eventObject.ReserveEnabled         = ticketSellOrder  === false ? 0 : 1
            theEvent.eventObject.hasNumberedSeats = numberedSeat
        
            fetchEventSave(theEvent.eventObject)
            setWaitingModal(true)

     
  
   }
  }, [internetOrder,internetSell, internetShow,ticketSellSell,ticketSellOrder,aclicked,bclicked,cclicked,dclicked,eclicked,numberedBtnClk,])


  //---deleteing exixting staff info -------
  function deleteStaffInfo () {
    setStaffText('')
    theEvent.eventObject.StaffInfo = ''
    fetchEventSave(theEvent.eventObject)
    setStaffInfoShown(false)

  }
//-----adding staff info ----------
const [staffInfoSaved, setStaffInfoSaved] = useState(false);
const [webInfoSaved, setWebInfoSaved] = useState(false);



function saveStaffInfo () {

 theEvent.eventObject.StaffInfo = staffTextInput
 fetchEventSave(theEvent.eventObject)
 setStaffInfoShown(false)
 setStaffInfoSaved(true)
}
// deleting existing web info---
function deleteWebInfo() {
  setWebText('')
  theEvent.eventObject.WebInfo=''
  fetchEventSave(theEvent.eventObject)
  setWebInfoShown(false)
}
// -------ADDING WEB INFO-------
function saveWebInfo () {
theEvent.eventObject.WebInfo = webTextInput
fetchEventSave(theEvent.eventObject)
setWebInfoShown(false)
setWebInfoSaved(true)
}

useEffect(() => {
  setIsShown(false)
  setMovieSelected(false)
  setMovieDivOpen(false)
},[selectedDate,deletebtnclk,savebtnclk])

   useEffect(() => {
    //  if(saveEditBtn === false) {
            setMovieSelected(selectAllFilmAtOnce === true && selectAllFilmAtOnce) 
    //   }  
 },[selectAllFilmAtOnce,saveEditBtn])



const handleMovieSelect = () => { 

  setMovieSelected((current) => !current);
  setAnyMovieSelected(anyMovieSelected === true ? true : (current) => !current)
  movieSelected === true ? setMovieUnselect(true) : setMovieUnselect()
}


//  const [evEdit, setevEdit] = useState(false);

useEffect(() => {
  theEvent.movieSelected = movieSelected
}, [movieSelected, theEvent]);


useEffect(() => {
  selectAllFilmAtOnce === false ? setMovieUnselect(false) :  setMovieUnselect()
}, [selectAllFilmAtOnce]);

useEffect(() => {
  daysEvent.map((ev) => {
    if(ev.event_No === theEvent.event_No) {
      theEvent.isOpen = movieDivOpen
    }
    else theEvent.isOpen = false
  })
  
}, [theEvent,movieDivOpen,daysEvent]);


 function handleInternetSell ()  {
   setBclicked((current) => !current)
   setInternetSell((current) => !current) // internet salg
  //  setWebbuyAlert((current) => !current)
 }

 function handleInternetShow ()   {
   setCclicked((current) => !current)
   setInternetShow((current) => !current) // intervisning
  //  setWebshowAlert((current) => !current)
 }
 function handleTicketSellSell  ()  {
   setDclicked((current) => !current)
   setTicketSellSell((current) => !current) // salg i billetsalg
  //  setBuyEnableAlert((current) => !current)
 }
 function handleTicketSellOrder  ()  {
   setEclicked((current) => !current)
   setTicketSellOrder((current) => !current) // bestilling i billetsalg
  //  setResEnabledAlert((current) => !current)
 }
 
  function handleInternetOrder  ()  {
    setInternetOrder((current) => !current) // internetbestilling
    setAclicked((current) => !current)
   
  }
  
 
  // function that checks if webreserveInfo is different in original and eventedit events
 function alertWebres (event) {

  let alert 
  all_events.map((ev) => {
       if(ev.No === event.event_No) {         
          if(event.eventObject.WebreserveInfo.enabled !== ev.WebreserveInfo.enabled) {
            alert = true
                     
          }
       }
    })
    return alert
 }
  // function that checks if webbuyInfo is different in original and eventedit events
  function alertWebbuy (event) {
    let alert
      all_events.map((ev) => {
         if(event.event_No === ev.No) {
            if(event.eventObject.WebbuyInfo.enabled !== ev.WebbuyInfo.enabled) {
              alert = true
              
            }
         }
      })
      return alert
   }
     // function that checks if webshowInfo is different in original and eventedit events
  function alertWebshow (event) {
    let alert
      all_events.map((ev) => {
         if(event.event_No === ev.No) {
            if(event.eventObject.WebshowInfo.enabled !== ev.WebshowInfo.enabled) {
              alert = true
             
            }
         }
      })
      return alert
   }
    // function that checks if buyEnabled is different in original and eventedit events
  function alertbuyEnabled (event) {
    let alert
      all_events.map((ev) => {
         if(event.event_No === ev.No) {
            if(event.eventObject.BuyEnabled !== ev.BuyEnabled) {
              alert = true
             
            }
         }
      })
      return alert
   }
// function that checks if buyEnabled is different in original and eventedit events
function alertresEnabled (event) {
  let alert
    all_events.map((ev) => {
       if(event.event_No === ev.No) {
       
          if(event.eventObject.ReserveEnabled !== ev.ReserveEnabled) {
            alert = true
            
          }
       }
    })
    return alert
 }

 function alertNumbered (event) {
    let alert   
    all_events.map((ev) => {
      if(event.event_No === ev.No) {
       
        if(event.eventObject.hasNumberedSeats !== ev.hasNumberedSeats) {
          alert = true
        
        }
  }
    })
  
    return alert
 }

 function alertWebinfo (event) {
   let alert
   all_events.map((ev) => {
      if(event.event_No === ev.No) {
          if(event.eventObject.WebInfo !== ev.WebInfo) {
            alert= true
          }
      }
   })
   return alert
 }
 function alertStaffinfo (event) {
  let alert
  all_events.map((ev) => {
     if(event.event_No === ev.No) {
         if(event.eventObject.StaffInfo !== ev.StaffInfo) {
           alert= true
         }
     }
  })
  return alert
 }

  const trailerWidth = theWidth * (adTrailer/movieLength)   // film div width

  const [maxTickets, setmaxTickets] = useState(theEvent.eventObject.MaxTickets);
  const [minTickets, setminTickets] = useState(theEvent.eventObject.MinTickets);

  function maxTicketChange (e) {
    setmaxTickets(e.target.value)
    let newMax = Number(e.target.value)
    theEvent.eventObject.MaxTickets = e.target.value > 0 ?  newMax : 0   
    fetchEventSave(theEvent.eventObject)
  }


  function minTicketChange (e) {  
    setminTickets(e.target.value)
    let newMin = Number(e.target.value)
    theEvent.eventObject.MinTickets = e.target.value > 0 ?  newMin : 0
   fetchEventSave(theEvent.eventObject)

  }

  
  return (
        
  <div style={{height:'43px',}}> 

 

    <div  style={{display:'flex',padding:'0',justifyContent:'space-between',}}>
          <span style={{position:'absolute',top:'-20px',fontSize:'12px'}}>
            {showTime && start_Time}</span>       
           <div className="shown_menu" style={{width:'82%',height:'43px',display:'flex', justifyContent:'space-between'}}>
            <div className="" style={{display:'flex',width:'100%',paddingTop:'8px',paddingRight:'10px'}}>

            {theDraggedElm.event_No === theEvent.event_No && dragging === true && theDraggedElm.event_No > 0 ?
             <span style={{position:'absolute',top:'-2px',fontSize:'12px'}}>{start_Time}</span> : null }

            { theDraggedElm.eventObject?.RefNo === theEvent.eventObject.RefNo && dragging === true && theDraggedElm.event_No === theEvent.event_No?
             <span style={{position:'absolute',top:'-2px',fontSize:'12px'}}>{start_Time}</span> : null }

              <span ><img className='doubleLine' style={{background:'transparent' , }}  src={iconScrub} alt='icon-scrub'/></span> 
              <div  className='film_check'  onClick={ handleMovieSelect} style={{background:'none'}}>
                <span>
                  {(movieSelected === true ||  selectAllFilmAtOnce === true) && movieUnselect !== true ?
                  <svg id={event_no > 0 ? event_no : ref_no} width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="0.75" y="1.25" width="14.5" height="14.5" rx="1.91667" stroke={movieNameColor}  stroke-width="1.5"/>
                  <path d="M5 7.44495L7.30044 10.6429L11 5.5" stroke={movieNameColor} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  :
                  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                   <rect x="0.75" y="1.25" width="14.5" height="14.5" rx="1.91667" stroke={movieNameColor} stroke-width="1.5"/>
                  </svg>
                  }
                </span>
                 
              </div>
              { localStorage.getItem('showTimePeriod') === 'true'? <div style={{position:'relative',width:'100%'}}> 
                         <p className='film_name' style={{color:movieNameColor,textDecoration:'underline',background:'none',position:'absolute',top:'-10px',fontSize:'14px'}}>{start_Time +'-'+ end_Time}</p>
                         <p className='film_name' style={{color:movieNameColor,textDecoration:'underline',background:'none',position:'absolute',top:'6px',width:'100%'}}>{film}</p>
              </div> 
              : 
      <p className='film_name' style={{color:movieNameColor,textDecoration:'underline',background:'none'}}>
              {localStorage.getItem('showTimePeriod') === 'true'?  start_Time +'-'+ end_Time+' : ' + film : film }
              </p>
              }
             
              

            </div>

          </div>
          <button className="arrow_btn" style={{marginLeft:'0px', width:'20px',marginRight:'10px',marginTop:'0px'}} id={event_no > 0 ? event_no : ref_no} 
          onClick= { () =>  handleClick(event_no) }
          // onClick={toggleOpen}
          >
                <span  id={event_no}> 
                  <svg  id={event_no}  xmlns="http://www.w3.org/2000/svg" width="8" height="10" viewBox="0 0 15 9" >
                  <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                  <g stroke={theEvent.movieLength === false ? 'black' :movieNameColor } strokeWidth="2.5">
                  <g>
                  <path d="M934 19.25L940.5 26.25 947 19.25" transform="translate(-1053 -509) translate(120 491)"/>
                   </g>
                   </g>
                   </g>
                   </svg> 
                </span>
        </button>
     

      {/* ALERT ICON when show edit begins  */}
    {
      theEvent.eventObject.RefNo > 0 &&  eventEdit === true  ? 
     <img style={{position:'absolute',right:'-5px',top:'17px',zIndex:1}} src={alertIcon} alt='alert-icon' /> : ''
       } 
        
       
    </div>  
  
    <div id={event_no} className="dropdown2-content" style={{display:'none',width:'100%',position:'absolute',zIndex:10}}>
    <div id='filmInfoDiv' className='div' style={{position:'relative', 
      zIndex: modalShown === true || internetmodalShown === true || intersellmodal === true || intershowmodal === true ? '' : staffInfoShown ? 1: 4, backgroundColor:  extendedBackColor ,marginTop: '-2px' , borderBottomLeftRadius:'4px', borderBottomRightRadius:'4px',}}>
   
    <>
          <main style={{padding: theWidth > 160 ? '5px' :'0px'}}>
           <div style={{paddingLeft: theWidth > 210 ? '8px' :'0px'}}>
            <p  style={{margin:0,paddingTop:'0px',color:'#46484c',display: theWidth < 120 ? '' : 'flex',height:theWidth < 90 ? '50px':'25px',flexDirection: theWidth < 90 ? 'column' : '',paddingLeft:theWidth<160?'5px':'',}}> 
              <p className='film_name text_elip' style={{fontWeight:700,paddingRight:'10px',maxWidth: theWidth < 120 ? '100%' :'50%',paddingTop:'0px',letterSpacing:'0.24px'}}>{salNr}</p> 
              <p style={{fontSize: theWidth < 185 ? '12px': '15px', lineHeight:theWidth < 120 ? '10px' : '23px'}}>{start_Time} - {end_Time} </p>
              </p>
            
            <div style={{paddingTop: theWidth < 120 ? ' 15px' : '10px',paddingLeft:theWidth<160?'5px':''}}>
         
               <div style={{display:'flex',marginTop:'0px',border:'1px ',height:'13px',marginBottom:showActiveText?'':'3px',position:'relative'}}>
               <img  onClick={() => handleInternetOrder(theEvent)} src= {
                selectAllFilmAtOnce === true ?
               ( (movieSelected === true && internetOrderAll === 1)  ?  small_checkmark   :    (movieSelected === true && internetOrderAll === 0) ? small_square 
                : theEvent.eventObject.WebreserveInfo?.enabled === 1 ? small_checkmark : small_square 
              ) 
                : (
                  internetOrder === true  ?  small_checkmark : small_square
                )
                 }  alt="checkmark"  />
                 <p onClick={(e) => {
                          setInternetmodalShown(!internetmodalShown);
                          
                      }} style={{fontSize:'12px',color:'#46484c',margin:'-4px 8px',textOverflow:'ellipsis',overflow:'hidden',whiteSpace:'nowrap',textDecoration:'underline'}}>Internetbestilling  </p>
               
                {  alertWebres(theEvent) === true  ? <img src={ alertIcon} alt='alert-icon' style={{position:'absolute',right:'0px'}} /> : '' }

               </div>
               {showActiveText === true ? 
               <p className='text_elip' style={{marginLeft:'20px',marginBottom:'2px',marginTop:'-2px',fontSize:'10px',fontWeight:700,letterSpacing:'0.2px',color:activeColor}}>{activeText}g
               </p>
               : ''}
               <InternetModal
        shown={internetmodalShown}
        close={() => {
          setInternetmodalShown(false);
        }} activeColor={activeColor}  popupbg2={popupbg2} sec1color = {extendedBackColor} sec2color={popupbg2} sec3color={popupbg3} data={theEvent.eventObject}></InternetModal>
              

               <div  style={{display:'flex',margin:0,padding:0,height:'13px',marginBottom:'3px',border:'1px ',position:'relative'}} >
               <img onClick={handleInternetSell}  src= {
                 selectAllFilmAtOnce === true ?
                 ((movieSelected === true &&  internetSellAll === 1)  ?  small_checkmark   : (movieSelected === true &&  internetSellAll === 0) ? small_square 
                 : internetSell === true ? small_checkmark : small_square

                 )
               : (  theEvent.eventObject?.WebbuyInfo?.enabled === 1   ?  small_checkmark : small_square )
               }  alt=""  />
                 <p onClick={(e) => { setIntersellmodal(!intersellmodal);
   }} style={{fontSize:'12px',padding:'0px',margin:'-4px 8px',color:'#46484c',textOverflow:'ellipsis',overflow:'hidden',whiteSpace:'nowrap',textDecoration:'underline'}}>Internet salg</p>
                      
                 { alertWebbuy(theEvent) === true ? <img src={ alertIcon} alt='alert-icon' style={{position:'absolute', right:'0px'}} /> :''}
               </div>
               <InternetSellModal
        shown={intersellmodal}
        close={() => {
          setIntersellmodal(false);
        }} activeColor={activeColor} popupbg2={popupbg2} sec1color = {extendedBackColor} sec2color={popupbg2}   data={theEvent.eventObject} />
               <div  style={{display:'flex',margin:0,padding:0,height:'13px',marginBottom:'3px',border:'1px ',position:'relative'}} >
               <img onClick={handleInternetShow} src= {
                selectAllFilmAtOnce === true ?
                ((movieSelected === true &&  internetShowAll === 1)  ?  small_checkmark   : (movieSelected === true &&  internetShowAll === 0) ? small_square 
                : theEvent.eventObject.WebshowInfo?.enabled === 1 ? small_checkmark : small_square)
              :  (internetShow === true   ?  small_checkmark : small_square )}  alt=""  />
                 <p onClick={(e) => {
                          setIntershowmodal(!intershowmodal);
                          
                      }} style={{fontSize:'12px',padding:'0px',margin:'-4px 8px',color:'#46484c',textOverflow:'ellipsis',overflow:'hidden',whiteSpace:'nowrap',textDecoration:'underline'}}>Intervisning</p>
                 {  alertWebshow(theEvent) === true ? <img src={ alertIcon} alt='alert-icon' style={{position:'absolute', right:'0px'}} /> :'' }
               </div>
      <InternetShowModal
        shown={intershowmodal}
        close={() => {
          setIntershowmodal(false);
        }} activeColor={activeColor} popupbg2={popupbg2} sec1color = {extendedBackColor} sec2color={popupbg2}  data={theEvent.eventObject}/>
               <div  style={{display:'flex',margin:0,padding:0,height:'13px',marginBottom:'3px',border:'1px',position:'relative'}} >
               <img onClick={handleTicketSellSell} src= {
                selectAllFilmAtOnce === true ?
                ((movieSelected === true &&  ticketSellAll === 1)  ?  small_checkmark   : (movieSelected === true &&  ticketSellAll === 0) ? small_square 
                : theEvent.eventObject.BuyEnabled === 1 ? small_checkmark : small_square)            
               : ( ticketSellSell === true  ?  small_checkmark : small_square) }  alt=""  />
                 <p onClick={(e) => {
                          
                      }} style={{fontSize:'12px',padding:'0px',margin:'-4px 8px',color:'#46484c',textOverflow:'ellipsis',overflow:'hidden',whiteSpace:'nowrap',textDecoration:'underline'}}>Salg i billetsalg</p>
                 {  alertbuyEnabled(theEvent) === true ? <img src={ alertIcon} alt='alert-icon'  style={{position:'absolute',right:'0px'}}/> :'' }
               </div>

               <div  style={{display:'flex',margin:0,padding:0,height:'13px',marginBottom:'3px',border:'1px ',position:'relative'}} >
               <img onClick={handleTicketSellOrder} src= {
                selectAllFilmAtOnce === true ?
                (
                  (movieSelected === true &&  ticketOrderAll === 1)  ?  small_checkmark   : (movieSelected === true &&  ticketOrderAll === 0) ? small_square 
                : theEvent.eventObject.ReserveEnabled === 1 ? small_checkmark : small_square
                )
                : (ticketSellOrder === true   ?  small_checkmark : small_square) }  alt=""  />
                 <p onClick={(e) => {                        
                      }} style={{fontSize:'12px',padding:'0px',margin:'-4px 8px',color:'#46484c',textOverflow:'ellipsis',overflow:'hidden',whiteSpace:'nowrap',textDecoration:'underline'}}>Bestilling i billetsalg</p>
                  {  alertresEnabled(theEvent) === true ? <img src={ alertIcon} alt='alert-icon' style={{position:'absolute',right:'0px'}} /> : '' } 
               </div>
             

            </div>
         
         </div>
         <div style={{display:'flex',fontSize:'12px',marginTop:'20px'}}>
          <label htmlFor="" style={{width:'90%',backgroundColor:'transparent',lineHeight:'12px'}}> Internet restriktion for maximum billetter :</label>
          <select name="" value={maxTickets} onChange={maxTicketChange} id="" style={{width:'50px',height:'22px',marginTop:'-5px'}}>
            <option value="ingen">Ingen</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>

          </select>
       
         </div>
         <div style={{display:'flex',fontSize:'12px',marginTop:'10px'}}>
          <label htmlFor="" style={{width:'90%',backgroundColor:'transparent',lineHeight:'12px'}}> Internet restriktion for minimum billetter :</label>
          <select name="" id="" value={minTickets} onChange={minTicketChange} style={{width:'50px',height:'22px',marginTop:'-5px'}}>
            <option value="ingen">Ingen</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
          </select>
       
         </div>
       
         <div style={{marginTop:'10px',color:'#46484c',backgroundColor:priceDivBackColor,position:'relative',padding:'5px',borderRadius:'4px'}}>
           <div id='priceDiv1' style={{display:'flex',flexDirection:'column',justifyContent:'center'}}>
            <p  style={{fontSize:'12px',margin:0, paddingTop:'4px',fontWeight:'bold'}}>{price} dkk</p>
            <p className='text_elip' style={{fontSize:'12px',margin:0 }}>{arrtypename}</p>
            <p className='text_elip'  style={{fontSize:'12px',margin:0 }}>
            Billettype: {theEvent.eventObject.TicketTypes?.length ?  theEvent.eventObject.TicketTypes.length : 0} valgte</p>
           </div>
           
           {/* <div  id='priceDiv2' style={{backgroundColor:priceDivBackColor,textAlign:'center',borderTopRightRadius:'5px',borderBottomRightRadius:'5px',width:'37%',alignContent:'center'}}> */}
            <button style={{border:'none',background:'transparent',textDecoration:'underline', fontFamily:'lato',color:'#46484c',fontSize:'12px',
            //  lineHeight:theWidth > 170 ?'50px' : '',
            padding:0,position:'absolute',right:'6px', top:'4px'}} onClick={() => {
                          toggleModal(!modalShown);
                      }}><img src={edit} alt ='edit'/>
            </button>

           {/* </div> */}
           
           <EditModal
        shown={modalShown}
        close={() => {
          toggleModal(false);
        }}
       movie_name={film} sal_nr={salNr} start_time={start_Time} end_time={end_Time} the_Event={theEvent.eventObject} priceGroups={ theEvent.PriceGroups} color1={extendedBackColor} color2={activeColor}  all_events={all_events}
      >   
        </EditModal>
         </div>

         <div style={{padding:'5px',display:'flex',marginLeft:theWidth>160?'5px':'0px',position:'relative'}} onClick={() => handleNumberedSeat(theEvent)}>
              <span> 
                <img style={{height:'13px'}} 
                src={numberedSeat === true ? small_square : small_checkmark} 
                alt="checkmark/square" />
                </span> 
              <span style={{fontSize:'12px',marginLeft:'5px',marginTop:'4px'}} className='text_elip'>Unummererede billetter</span>
           { alertNumbered(theEvent) === true ?  
           <img src={ alertIcon} alt='alert-icon' style={{position:'absolute', right:'0px',top:'10px'}} />
            : ''}
          </div>
          
         <div style={{height:'20px',borderRadius:'4px',display:'flex', justifyContent:'space-between',backgroundColor:timelineBackColor,fontSize:'13px',color:movieNameColor,margin:theWidth>160 ?'0px 5px':'0px'}}>
           <span style={{backgroundColor:adTrailer ? '#8d8e7e':'', width: adTrailer ? 
            `${Math.round(trailerWidth)}px` : '0px',borderTopLeftRadius:'2px',borderBottomLeftRadius:'2px',paddingLeft:'2px'}}>0:{adTrailer > 9 ? '':'0'}{adTrailer}</span> 
           <span style={{fontWeight:'bold', paddingRight:'2px'}}>0{Math.floor(totalTimeInMin / 60) + ':'}{(totalTimeInMin % 60) < 10 ? '0'+ totalTimeInMin % 60 :  totalTimeInMin % 60}</span>
           
        </div>
       
          </main>
         
         
          </>
          
    </div>
    <div style={{backgroundColor: extendedBackColor,borderTop:'2px solid  white',borderRadius:'4px',height:staffInfoShown?'auto':'29px',fontSize:'12px',zIndex:staffInfoShown ? 15 :3,position:'relative',paddingTop:'3px',minHeight:staffInfoShown?'70px':''}}>
    <div style={{display:'flex',justifyContent:'space-between',padding: theWidth > 190 ? '0px 10px' : theWidth > 140 ? '0px 5px':''}}>
      <div style={{position:'relative'}}>
        <span className='text_elip' style={{marginTop:'2px', width: theWidth<140 ? '60px':''}}>Note i BilletPro</span> 
         { alertStaffinfo (theEvent) === true ? <img src={ alertIcon} alt='alert-icon' style={{position:'absolute', right:'-18px',top:'4px'}} /> : ''}
       </div>
       <div> 
           {staffInfoShown ? 
           <>
           {/* { staffText.length ?  */}
           <button  onClick={deleteStaffInfo}
            disabled={ (staffText === '' && staffTextInput === '') || theEvent.StaffInfo !== 'null'  ? true : false
              // (staffText || staffTextInput) == 'null' || (staffText || staffTextInput) == '' ? true : false
            } 
           style={{textDecoration:'underline',marginRight:theWidth > 200 ?'5px':'', cursor:'pointer',width:theWidth < 170 ? '25px':''
           
           }}>Slet
            </button> 
           
            <button  onClick={saveStaffInfo}
             disabled={(staffText || staffTextInput) == 'null' || ( staffTextInput.length < 1 )? true : false} 
           style={{textDecoration:'underline',marginRight:theWidth>140?'5px':'',width:theWidth < 170 ? '27px':''
           
           }}>Gem
            </button> 
           
            </>
            : '' } 
           <button style={{marginRight: theWidth > 160?'-5px':''}} onClick={(e) => staffInfoClick(e)} >
                <svg style={{ transform: staffInfoShown?'rotate(180deg)' : ''}} xmlns="http://www.w3.org/2000/svg" width="8" height="10" viewBox="0 0 15 9" >
                  <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                  <g stroke="#46484c" strokeWidth="2.5">
                  <g>
                  <path d="M934 19.25L940.5 26.25 947 19.25" transform="translate(-1053 -509) translate(120 491)"/>
                   </g>
                   </g>
                   </g>
                </svg>  
            </button>
                   
        </div>
          </div>
            {staffInfoShown ?
             <div class="textarea" id='textarea' style={{border:  `1px solid ${timelineBackColor}`}}  onInput={(e) => handleStaffInfo(e)} contentEditable="true">
              {staffText ? staffText : staffInfoSaved === true ? staffTextInput : staffText }
              </div> 
              : ''}
    </div>
    <NoteModal shown={(staffInfoShown && !staffText) || reEdit  ||  (webInfoShown && !webText)  } />

    <div style={{backgroundColor: extendedBackColor ,borderTop:'2px solid white',borderRadius:'4px',height:webInfoShown?'auto':'29px',fontSize:'12px',zIndex:webInfoShown?15:3,position:'relative',paddingTop:'3px',minHeight:webInfoShown?'70px':''}}>
      <div style={{display:'flex',justifyContent:'space-between',padding: theWidth > 170 ? '0px 10px' : theWidth > 140? '0px 5px ': ''}}>
        <div style={{position:'relative'}}>
          <span className='text_elip'  style={{marginTop:'2px',width: theWidth<140 ? '60px' :''}}>Note på webside</span>
         { alertWebinfo (theEvent) === true ? <img src={ alertIcon} alt='alert-icon' style={{position:'absolute', right:'-18px',top:'4px'}} /> : '' } 

      </div>
      <div> 
           {webInfoShown? 
           <>
           <button onClick={deleteWebInfo}
            disabled={ (webText === '' && webTextInput === '') || theEvent.WebInfo !== 'null' ? true : false
              // (webText || webTextInput) == 'null' || (webText || webTextInput) == '' ? true : false
              }  style={{textDecoration:'underline',marginRight: theWidth > 200 ? '5px':'',width:theWidth < 170 ? '23px':''}}  >Slet</button> 

           <button onClick={saveWebInfo} 
           disabled={(webText || webTextInput) == 'null' || ( webTextInput.length < 1 )? true : false}  style={{textDecoration:'underline',marginRight:theWidth>200?'5px':'',width:theWidth < 170 ? '23px':''}}  >Gem</button> 
           </>
           : '' } 
           <button style={{marginRight:theWidth > 160?'-5px':''}} onClick={(e) => webInfoClick(e)} >
               <svg style={{ transform: webInfoShown?'rotate(180deg)' : ''}}xmlns="http://www.w3.org/2000/svg" width="8" height="10" viewBox="0 0 15 9" >
                  <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                  <g stroke="#46484c" strokeWidth="2.5">
                  <g>
                  <path d="M934 19.25L940.5 26.25 947 19.25" transform="translate(-1053 -509) translate(120 491)"/>
                   </g>
                   </g>
                   </g>
                </svg>  
            </button>
                   
        </div>
        </div>
        {webInfoShown ?
          <div class="textarea" id='textarea' style={{border:  `1px solid ${timelineBackColor}`}} onInput={(e) => handleWebInfo(e)} contentEditable="true"> {webText ? webText : webInfoSaved === true ? webTextInput : webText }</div>
                  //  <textarea  type='text' 
                  // //  onChange={(e) => handleStaffInfo(e)}  
                  //  style={{position:'absolute',left:'7px',right:'7px',top:'25px',border:  `1px solid ${timelineBackColor}`,outline:'none',padding:'5px'}}/> 
                   : ''}
    </div>

    </div>

     </div>
      
  )
}

export default FilmWidget